var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "#6AC259",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61499 22.6154C9.61499 24.2085 10.9067 25.5002 12.4998 25.5002C14.0929 25.5002 15.3844 24.2086 15.3844 22.6154V10.3485L20.076 15.0399C20.6389 15.6032 21.3773 15.8847 22.1155 15.8847C22.8535 15.8847 23.5918 15.6032 24.1551 15.04C25.2816 13.9134 25.2816 12.087 24.1551 10.9604L14.5563 1.36179C14.3025 1.1038 14.0005 0.893352 13.665 0.74501C13.3086 0.587488 12.9144 0.5 12.4998 0.5C11.6873 0.5 10.9532 0.835945 10.4288 1.37651L0.844965 10.9603C-0.281655 12.0869 -0.281655 13.9133 0.844965 15.0399C1.97139 16.1666 3.79802 16.1666 4.92439 15.0399L9.61499 10.3495V22.6154Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGreen);
export default __webpack_public_path__ + "static/media/arrow-up-green.f0d57b9cc1e3e01f2c1d6a27f7420b83.svg";
export { ForwardRef as ReactComponent };